import { ValidatedPayeeAccountValidationStatusSupplierValidationVerification } from '@app/domain/validatedPayeeAccount';
import { DataPointType } from './NewVerificationTab.data';

export const DEFAULT_AMOUNT = '-';

export const EMPTY_VALUE = '-';

export const NOT_RELEVANT = 'Not relevant';

export const ADDITIONAL_BANK_CODE_LABEL = 'Additional Bank Code';

export const DATE_FORMAT = {
  DISPLAY: 'DD.MM.YYYY',
  LOCALE: 'en-GB',
} as const;

export const VALIDATION_TYPE_OPTIONS: ValidatedPayeeAccountValidationStatusSupplierValidationVerification[] = [
  ValidatedPayeeAccountValidationStatusSupplierValidationVerification.arDirect,
  ValidatedPayeeAccountValidationStatusSupplierValidationVerification.arLinked,
  ValidatedPayeeAccountValidationStatusSupplierValidationVerification.alreadyValidated,
  ValidatedPayeeAccountValidationStatusSupplierValidationVerification.bankValidation,
  ValidatedPayeeAccountValidationStatusSupplierValidationVerification.direct,
  ValidatedPayeeAccountValidationStatusSupplierValidationVerification.internalValidation,
  ValidatedPayeeAccountValidationStatusSupplierValidationVerification.light,
  ValidatedPayeeAccountValidationStatusSupplierValidationVerification.linked,
  ValidatedPayeeAccountValidationStatusSupplierValidationVerification.lyonsValidation,
];

export const MODAL_LABELS = {
  VALUE: 'Value',
  PRESETS: 'Presets',
  VENDOR_REGISTRATION: 'Vendor Registration:',
  EVIDENCE_ENRICHMENT: 'Evidence/Enrichment:',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  RESET: 'Reset',
} as const;

export const DELETE_CONFIRM_LABELS = {
  ROW_TITLE: 'Delete Row',
  ROW_DESCRIPTION: 'Are you sure you want to delete this row? This action cannot be undone.',
  ACCOUNT_SECTION_TITLE: 'Delete Account Details Section',
  ACCOUNT_SECTION_DESCRIPTION: 'Are you sure you want to delete this account details section? This action cannot be undone.',
  DELETE: 'Delete',
  CANCEL: 'Cancel',
} as const;

export const COLUMN_KEYS = {
  DATA_POINT: 'dataPoint',
  VENDOR: 'vendor',
  EVIDENCE: 'evidence',
  AUTOMATED_MATCHING: 'automatedMatching',
  MANUAL_PROCESS: 'manualProcess',
  FINAL_REVIEW: 'finalReview',
} as const;

export const COLUMN_TYPES = {
  MANUAL_PROCESS: 'manualProcess',
  FINAL_REVIEW: 'finalReview',
} as const;

export const PARTIAL_MATCH_REASON_LABELS: Record<string, string> = {
  CountryMatchByEvidence: 'Country matched by evidence',
  LeadingThe: 'Leading "The"',
  AbbreviationFullTerm: 'Abbreviation / full term',
  MissingSuffixInRegistration: 'Missing suffix in registration',
  MissingSuffix: 'Missing suffix',
  NameMatchLegalSuffix: 'Name Match - legal suffix',
  IbanCalcMatch: 'IBAN calculation match',
  LeadingZerosMatch: 'Leading zeros match',
  IdType: 'ID type difference',
  MissingRegistrationCountryCode: 'Missing registration country code',
  IdEnrichmentFr: 'ID enrichment (FR)',
  IdMatchingACH: 'ID matching via ACH',
  AdditionalLeiEvidenceMatch: 'Additional LEI matched by evidence',
  SwiftEvidenceMatch: 'SWIFT matched by evidence',
  SwiftDatabaseMatch: 'SWIFT matched by database',
  // ABA routing
  AdditionalBankCodeDatabaseMatch: 'Additional Bank Code - Database Match',
  // Address
  AddressSubpremiseMismatch: 'Address - Sub-premise Mismatch',
};

/** Maximum number of child rows that can be added per data-point type. */
export const DATA_POINT_ADD_LIMITS: Record<DataPointType, number> = {
  name: 1,
  address: 1,
  legalIdentifiers: Infinity,
  country: Infinity,
  accountCountry: Infinity,
  bankName: Infinity,
  bankCode: 1,
  branchCode: Infinity,
  iban: Infinity,
  swiftCode: Infinity,
  accountNumber: Infinity,
  forFurtherCredit: Infinity,
  clabe: 1,
};
